import useResource from "../../../hooks/UseResource";
import * as InjuryClassService from "../../../services/InjuryClassService";

export default function useInjuryClass(id) {
    return useResource(id, InjuryClassService.findInjuryClassById);
}
